// extracted by mini-css-extract-plugin
module.exports = {"bat":"Halloween_bat__34ot7","bob":"Halloween_bob__0jaBa"};